// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Sqz_","tabsBox":"styles_tabsBox__2U5Zb","createButton":"styles_createButton__3dN0K"};